(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientStatusDeleteController',PatientStatusDeleteController);

    PatientStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatientStatus'];

    function PatientStatusDeleteController($uibModalInstance, entity, PatientStatus) {
        var vm = this;

        vm.patientStatus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PatientStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
